// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./mapbox.polylabel.d.ts" />

import poleOfInaccessibility from "@mapbox/polylabel";

export const calculatePoleOfInaccessibility = (
    polygon: number[][][],
    precision?: number,
    debug?: boolean
): number[] & { distance: number } => poleOfInaccessibility(polygon, precision, debug);

export const WGS84_POLE_OF_INACCESSIBILITY_PRECISION = 0.00001;
